import { render } from "./SocialsFooter.vue?vue&type=template&id=3a9b519e&scoped=true"
import script from "./SocialsFooter.vue?vue&type=script&lang=js"
export * from "./SocialsFooter.vue?vue&type=script&lang=js"

import "./SocialsFooter.vue?vue&type=style&index=0&id=3a9b519e&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9b519e"]])

export default __exports__